'use client';

import { useEffect } from 'react';
import { getGoogleSettings } from '@/utils/env';

interface GtmObject {
  'gtm.start': number;
  event: 'gtm.js';
}

const GoogleTagManager = () => {
  useEffect(() => {
    const googleSettings = getGoogleSettings();

    const id = googleSettings?.gtm.id;
    const auth = googleSettings?.gtm.auth;
    const preview = googleSettings?.gtm.preview;

    if (id) {
      ((w: Window & typeof globalThis, d: Document, s: 'script', l: 'dataLayer') => {
        w[l] = w[l] || [];
        if (w[l]) {
          (w[l] as GtmObject[]).push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
          });
        }

        const a = auth ? `&gtm_auth=${auth}` : '';
        const p = preview ? `&gtm_preview=${preview}` : '';

        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l !== 'dataLayer' ? `&l=${l}` : '';

        j.async = true;
        j.src = `https://www.googletagmanager.com/gtm.js?id=${id}${dl}${a}${p}`;
        if (f.parentNode) {
          f.parentNode.insertBefore(j, f);
        }
      })(window, document, 'script', 'dataLayer');
    }
  }, []);

  return null;
};

export default GoogleTagManager;
